import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import { Modal } from '@web/components';
import {
  ModalContainer,
  ModalHeading,
  ModalContent,
  ModalContentBody,
} from './styles';
import {
  RETURNING_USER_ARIA_LABEL,
  RETURNING_USER_TITLE,
  RETURNING_USER_MESSAGE,
  RETURNING_USER_CONTINUE_BUTTON,
} from './constants';

export const UserReturnModal = ({ showModal, onCloseModal }) => {
  return (
    <Modal
      ariaLabel={RETURNING_USER_ARIA_LABEL}
      shown={showModal}
      mobilePopUp={true}
      popupMobileDialoguePadding={6}
      onCloseModal={onCloseModal}
    >
      <ModalContainer>
        <ModalHeading>{RETURNING_USER_TITLE}</ModalHeading>
        <ModalContent>
          <ModalContentBody>{RETURNING_USER_MESSAGE}</ModalContentBody>
          <Button fullWidth variant="primary" onClick={onCloseModal}>
            {RETURNING_USER_CONTINUE_BUTTON}
          </Button>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

UserReturnModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

UserReturnModal.displayName = 'UserReturnModal';
